import { render, staticRenderFns } from "./scheduleAxis.vue?vue&type=template&id=351bba8c&scoped=true&"
import script from "./scheduleAxis.vue?vue&type=script&lang=js&"
export * from "./scheduleAxis.vue?vue&type=script&lang=js&"
import style0 from "./scheduleAxis.vue?vue&type=style&index=0&id=351bba8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351bba8c",
  null
  
)

export default component.exports